/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SqlStatistics
 */
export interface SqlStatistics {
    /**
     * 
     * @type {string}
     * @memberof SqlStatistics
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SqlStatistics
     */
    executionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SqlStatistics
     */
    executionTime?: number;
    /**
     * 
     * @type {number}
     * @memberof SqlStatistics
     */
    percentage?: number;
}

/**
 * Check if a given object implements the SqlStatistics interface.
 */
export function instanceOfSqlStatistics(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SqlStatisticsFromJSON(json: any): SqlStatistics {
    return SqlStatisticsFromJSONTyped(json, false);
}

export function SqlStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SqlStatistics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'executionCount': !exists(json, 'executionCount') ? undefined : json['executionCount'],
        'executionTime': !exists(json, 'executionTime') ? undefined : json['executionTime'],
        'percentage': !exists(json, 'percentage') ? undefined : json['percentage'],
    };
}

export function SqlStatisticsToJSON(value?: SqlStatistics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'executionCount': value.executionCount,
        'executionTime': value.executionTime,
        'percentage': value.percentage,
    };
}

